import { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';
import UserInterface from 'interface/user';
import {
  isExpired,
  isTrialPeriod,
  isUnregisteredAuthoringService,
} from 'utils/helper';

interface PermissionRouteProps {
  user: UserInterface | null;
  children: ReactElement;
}

const PermissionRoute = (props: PermissionRouteProps) => {
  const { user, children } = props;

  if (
    user &&
    (isUnregisteredAuthoringService(user) ||
      (isTrialPeriod(user) && isExpired(user)))
  )
    return <Redirect to="/" />;

  return children;
};

export default PermissionRoute;
